import { featureState, type FeatureState, type ProductFeature, type ProductFeatureMap } from '@tfa/shared'

/**
 * Замки и «серым» по тарифу (три тарифа, этап 2).
 *
 * Раздел под замком — рейтинг, ИИ-Павел, магазин, обучение: видно размытый
 * настоящий экран, поверх — иконка, заголовок и кнопка «Получить доступ к
 * полному функционалу» в отдел продаж. Тексты — из прототипа тарифов.
 */
export const SALES_URL = 'https://t.me/tulupavel_fits'
export const LOCK_CTA = 'Получить доступ к полному функционалу'

export interface LockText { icon: string; title: string; subtitle: string }

export const LOCK_TEXTS: Partial<Record<ProductFeature, LockText>> = {
  lectures: { icon: '📚', title: 'Лекции входят в программу ТФА', subtitle: '84 урока: питание, тренинг, гормоны, восстановление' },
  leaderboard: { icon: '🏆', title: 'Лига и баллы — в программе ТФА', subtitle: 'Каждую неделю новая комната на 20 человек' },
  challenges: { icon: '🎯', title: 'Челленджи — в программе ТФА', subtitle: 'Задания на неделю и монеты за выполнение' },
  ai: { icon: '🤖', title: 'ИИ-Павел отвечает участникам ТФА', subtitle: 'Спросить про питание, тренировки и правила программы' },
  shop: { icon: '🛍️', title: 'Монеты копятся в программе ТФА', subtitle: 'Их тратят на заморозки, мерч и разбор с Павлом' },
  character: { icon: '🧬', title: 'Персонаж, уровни и лига — в полной программе ТФА', subtitle: 'Он растёт за тренировки и отчёты, поднимает уровень и выводит тебя в лигу' },
}
const DEFAULT_LOCK: LockText = { icon: '🔒', title: 'Доступно в полной программе ТФА', subtitle: '' }
export const lockText = (feature: ProductFeature): LockText => LOCK_TEXTS[feature] ?? DEFAULT_LOCK

/** Функция, которой принадлежит маршрут; null — маршрут не гейтится по тарифу. */
export function routeFeature(pathname: string): ProductFeature | null {
  if (pathname.startsWith('/content') || pathname.startsWith('/lectures')) return 'lectures'
  if (pathname.startsWith('/leaderboard')) return 'leaderboard'
  if (pathname.startsWith('/challenges')) return 'challenges'
  if (pathname.startsWith('/shop')) return 'shop'
  return null
}

export interface TabLike { feature: ProductFeature | null }

/**
 * Вкладки таб-бара по тарифу: открытые — как есть, под замком — видны с
 * замком (ТЗ: «вкладок пять, как везде»), выключенные — скрыты.
 */
export function tabsForAccess<T extends TabLike>(
  tabs: T[],
  product: string | null | undefined,
  access?: Partial<ProductFeatureMap> | null,
): Array<T & { locked: boolean; state: FeatureState }> {
  const out: Array<T & { locked: boolean; state: FeatureState }> = []
  for (const t of tabs) {
    if (!t.feature) { out.push({ ...t, locked: false, state: 'open' }); continue }
    const state = featureState(product, t.feature, access)
    if (state === 'open') out.push({ ...t, locked: false, state })
    else if (state === 'locked') out.push({ ...t, locked: true, state })
  }
  return out
}
